import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  width: '100%',
  marginTop: 24,
};

export const titleStyle: CSSProperties = {
  margin: 0,
};

export const coeficienteVariacaoAltoStyle: CSSProperties = {
  color: '#ff4d4f',
};

export const coeficienteVariacaoBaixoStyle: CSSProperties = {
  color: '#52c41a',
};

export const limiteSuperiorStyle: CSSProperties = {
  color: '#52c41a',
};

export const limiteInferiorStyle: CSSProperties = {
  color: '#ff4d4f',
};

export const percentualStyle: CSSProperties = {
  fontSize: 11,
  marginLeft: 4,
};
